<template>
  <div
    class="fourth-page-root"
    ref="navBox"
    :class="{ 'a-fadeinB': changeClassName }"
  >
    <div class="content">
      <div class="title">发展历程</div>
      <img src="../../assets/displayPage/seventh.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { observer: null, changeClassName: false };
  },
  computed: {},
  watch: {},
  mounted() {
    this.setObserver();
  },
  beforeDestroy() {
    this.disconnectObservers();
  },
  methods: {
    disconnectObservers() {
      if (this.observer) {
        this.observer.unobserve(this.$refs.navBox); //解绑元素
        this.observer.disconnect(); //停止监听
      }
    },
    setObserver() {
      this.observer = new IntersectionObserver((entries) => {
        // this.timeOut = setTimeout(() => {
        this.changeClassName = entries[0].isIntersecting;
        // clearTimeout(this.timeOut)
        // this.timeOut = null
        // }, 500)
      });
      this.observer.observe(this.$refs.navBox);
    },
  },
};
</script>

<style lang="scss" scoped>
.fourth-page-root {
  width: 100%;
  height: 927px;
  background: linear-gradient(
    180deg,
    #ffffff 3%,
    #faf8f8 22%,
    #f7faff 88%,
    #ffffff 100%
  );
  .content {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 72px;
    .title {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 32px;
      color: #121218;
      line-height: 46px;
      margin-bottom: 56px;
      text-align: center;
    }
    img {
      width: 1200px;
      height: 682.6px;
    }
  }
}

.a-fadeinB {
  animation: fadeinB 1s ease-out backwards;
}
@keyframes fadeinB {
  0% {
    opacity: 0;
    transform: translate3d(0, 10%, 0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    transform: translate3d(0, 0, 0);
  }
}
</style>
